export default "__VITE_ASSET__D2FnHc0i__"